"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyPointDetailRequest = void 0;
var MyPointDetailRequest = /** @class */ (function () {
    function MyPointDetailRequest() {
    }
    return MyPointDetailRequest;
}());
exports.MyPointDetailRequest = MyPointDetailRequest;
;
//# sourceMappingURL=myPointDetailNew.request.js.map